export { default as ExtraUniversityList } from './extra-university-list';
export { default as FirstSection } from './first-section';
export { default as InfoSection } from './info-section';
export { default as MainInformation } from './main-information';
export { default as UniversityStatistics } from './university-statistics';
